import React from 'react';
import Checkbox from 'ui/Checkbox';

interface IVoucherVisibilityOptionsProps {
  peBookingNumberIsVisible: boolean;
  travelPartnerReferenceIsVisible: boolean;
  destinationDetailsIsVisible: boolean;
  onPeBookingNumberVisibilityChange: (isVisible: boolean) => void;
  onTravelPartnerReferenceVisibilityChange: (isVisible: boolean) => void;
  onDestinationDetailsVisibilityChange: (isVisible: boolean) => void;
}

export const VoucherVisibilityOptions: React.FC<IVoucherVisibilityOptionsProps> = ({
  peBookingNumberIsVisible,
  travelPartnerReferenceIsVisible,
  destinationDetailsIsVisible,
  onPeBookingNumberVisibilityChange,
  onTravelPartnerReferenceVisibilityChange,
  onDestinationDetailsVisibilityChange,
}) => {
  return (
    <div className="mb-8">
      <span className="font-pt-sans font-bold text-[17px] text-black mb-4 block">More Info</span>
      <div className="flex flex-row gap-6 mb-6">
        <label className="flex items-center gap-3 cursor-pointer">
          <Checkbox
            checked={peBookingNumberIsVisible}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              onPeBookingNumberVisibilityChange(e.target.checked);
            }}
          />
          <span className="text-base font-pt-sans">Show Booking Ref.</span>
        </label>
        <label className="flex items-center gap-3 cursor-pointer">
          <Checkbox
            checked={travelPartnerReferenceIsVisible}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              onTravelPartnerReferenceVisibilityChange(e.target.checked);
            }}
          />
          <span className="text-base font-pt-sans">Show Travel Partner Ref.</span>
        </label>
        <label className="flex items-center gap-3 cursor-pointer">
          <Checkbox
            checked={destinationDetailsIsVisible}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              onDestinationDetailsVisibilityChange(e.target.checked);
            }}
          />
          <span className="text-base font-pt-sans">Show Destination Details</span>
        </label>
      </div>
    </div>
  );
};